// display lisint optimisation content
export const displayListingOptimisationInfo = (formData) => {
  return `<p>*The number of Listing Optimizations per month may vary according to changing strategic priorities and   serves as a guideline, not a guarantee. Listing Optimization ASINs may be applied to all children in a single parent ${
    formData?.isNewChannel ? 'SKU' : 'ASIN'
  } only if unique copy and infographics are not required. If the child listings require different infographics and/or copy, or if there are more than 5 child listings, additional fees may apply. Infographics include up to 5 screens per ${
    formData?.isNewChannel ? 'SKU' : 'ASIN'
  }.</p><br />   
    <p>Listing Optimization Services may be substituted for services of similar value as agreed upon in writing by both the Brand Growth Strategist and Client. These services may include but are not limited to: SEO Keyword Optimization, ${
      formData?.channel?.value === 'amazon' ? 'A+' : 'Enhanced'
    } Content Design, Brand Story, Style Guides, Improvement or Optimization, Premium ${
    formData?.channel?.value === 'amazon' ? 'A+' : 'Enhanced'
  } Content Design or Variations, ${
    formData?.channel?.label
  } Store Front Design or Optimization, Infographic creation or optimization, Graphic & Copy Translation Services. </p><br />
    <p>Should a set amount of optimization or creative services not be delivered within a set month, those agreed upon deliverables may be completed by the end of the contract term at the latest.</p><br />
    <p>Delivering the scheduled number of optimization services requires the Client to deliver assets to BBE, approve a brand sample, and respond to requests for feedback in a timely manner. Each Creative Deliverable is allowed 2 free revisions in order to maintain an effective delivery schedule. Delays in delivering assets, providing feedback or requests for more than 2 revisions may delay deliverables. Please see Revisions Policy Guidelines next section for more information.</p>`;
};

// display revision content in document
export const displayRevisionPolicyInfo = () => {
  return `<p><span style="font-weight: 800; font-family: Helvetica-bold;">What is a Revision?</span></p>
        <p>A revision is any change or ‘edit’ requested by Client to a deliverable before upload.</p>
        <ul>
          <li>Changes to previously uploaded BBE deliverables are considered ‘updates’ or ‘refreshes’.</li>
        </ul>
        <p><span style="font-weight: 800;
        font-family: Helvetica-bold;">Revision Policy</span></p>
        <p>Client will receive 2 free rounds of revisions to a deliverable prior to upload.</p>
        <ul>
          <li>If Client wants further revisions to a deliverable, they can be substituted for contracted creative work or purchased at the fee schedule in place at the time of the request.
          </li>
          <li>When a change or 'edit' to a deliverable is requested, that is considered the 1st round. A request for a change to the deliverable after that will be regarded as the 2nd round.</li>
        </ul>
        <p>All revision notes or ‘edits’ should be submitted at the same time.</p>
        <ul>
          <li>After creative work is delivered, Client should take 1-2 weeks to review the deliverables with all the stakeholders on their end and submit all revision notes at the same time.</li>
        </ul>
      `;
};

export const renderStdServiceRow = (service) => {
  const fields = [];
  for (const item of service) {
    if (!item.value && !item.label) {
      fields.push(
        `<td style="border: 1px solid black; padding: 13px;">${item.name}</td>`,
      );
    } else {
      fields.push(
        `<td style="border: 1px solid black; padding: 13px;">Listing Optimization - ${item.label} <br>
              *May vary by strategic priorities, <span style="font-weight: 800;">up to  <span style=" background:#ffe5df; padding: 4px 9px; font-weight: bold"> 
                ${item.value}
              </span>ASINs
              </span>per month
            </td>`,
      );
    }
  }
  return fields;
};

export const mapStandardServices = (formData) => {
  if (
    (formData?.standard_us_services && formData?.standard_us_services.length) ||
    formData?.content_optimization ||
    formData?.design_optimization
    // formData?.photography_optimization
  ) {
    let content = {};
    let design = {};
    // let photo = {};

    if (formData?.content_optimization) {
      content = {
        label: 'Copy',
        value: formData.content_optimization,
      };
    }
    if (formData?.design_optimization) {
      design = {
        label: 'Design',
        value: formData.design_optimization,
      };
    }

    const fields = [];
    // combine the standard services with listing optimization to show it properly in the table dynamically.
    let temp = [];
    if (formData?.standard_us_services?.length)
      temp = [...temp, ...formData.standard_us_services];
    if (content && Object.keys(content).length !== 0) temp = [...temp, content];
    if (design && Object.keys(design).length !== 0) temp = [...temp, design];

    const formattedData = new Array(Math.ceil(temp.length / 3))
      .fill()
      .map(() => temp.splice(0, 3));
    for (const item of formattedData) {
      fields.push(`<tr> ${renderStdServiceRow(item)} </tr>`);
    }
    return fields.length ? fields.toString().replaceAll(',', '') : '';
  }
  return '';
};

export const showStandardServicesTable = (formData) => {
  if (
    (formData.standard_us_services?.length === 0 ||
      formData.standard_us_services === null) &&
    !formData.content_optimization &&
    !formData.design_optimization &&
    !formData.photography_optimization
  )
    return ``;
  return `<div class="text-center BT-SOW-standard-service mt-4" style="margin-top: 1.5rem !important; text-align:center;"><span style="font-weight: 800; font-family: Helvetica-bold;">Standard Services</span>
       <br> The following services will be provided to client during the term of the contract.</div><br/>
      <div class="table-responsive">
        <table class="contact-list" style="width: 100%; overflow:auto; border-collapse: collapse;">
          <tr><th colspan="3" style="text-align: left; border: 1px solid black;padding: 13px;">Service Components</th></tr>
            ${mapStandardServices(formData)}
        </table>
        ${
          formData?.design_optimization ||
          formData?.content_optimization ||
          formData?.photography_optimization
            ? `<br />
            ${displayListingOptimisationInfo(formData)}
            <br />
            ${displayRevisionPolicyInfo()}`
            : ''
        }
      </div>
    `;
};

export const displayChannelServiceRow = (service) => {
  const fields = [];
  for (const item of service) {
    fields.push(
      `<td style="border: 1px solid black; padding: 13px;">${item.name}</td>`,
    );
  }
  return fields.length ? fields.toString().replaceAll(',', '') : '';
};

export const showChannelServicesTable = (formData) => {
  if (!formData.channel_services || formData.channel_services.length === 0) {
    return `<span style=" background:#ffe5df;padding: 4px 9px; font-weight: bold">Select Channel Services</span>`;
  }

  const mapChannelServices = () => {
    const fields = [];
    let temp = [];
    if (formData?.channel_services?.length) {
      temp = [...temp, ...formData.channel_services];
    }

    const formattedData = new Array(Math.ceil(temp.length / 3))
      .fill()
      .map(() => temp.splice(0, 3));

    for (const service of formattedData) {
      fields.push(`<tr>
        ${displayChannelServiceRow(service)}
        </tr>`);
    }
    return fields.length ? fields.toString().replaceAll(',', '') : '';
  };

  return `<div class="text-center BT-SOW-standard-service mt-4" style="margin-top: 1.5rem !important; text-align:center;">
      <div class="table-responsive">
        <table class="contact-list" style="width: 100%; overflow:auto; border-collapse: collapse;">
          <tr><th colspan="3" style="text-align: left; border: 1px solid black;padding: 13px;">Channel Services</th></tr>
            ${mapChannelServices()}
        </table>
      </div>
    `;
};
